// Environment variables are replaced at build time by Angular
// To use .env file, create .env.local and add your keys there
// They will be loaded from localStorage in the component
export const environment = {
  production: false,
  version: '2.0.5',
  appName: 'Browser Pilot AI (DEV)',

  // Supabase Configuration
  supabase: {
    url: 'https://zrdukgvobgkhbbltudzw.supabase.co',
    publicKey: 'sb_publishable_eD8i_gOItcgQQRhg9xBT2A_pnD526Mq',
    edgeFunctions: {
      octoProfiles: '/functions/v1/octo-profiles'
    },
    // Proxy Interceptor Configuration
    proxyRoutes: [
      {
        baseUrl: 'https://app.octobrowser.net',
        functionName: 'octo-proxy'
      }
    ]
  },

  // OctoBrowser Configuration
  octobrowser: {
    cloudApiUrl: 'https://app.octobrowser.net',
    localApiUrl: 'http://localhost:58888'
  },

  // Browser Use API Configuration
  browserUse: {
    apiUrl: 'http://localhost:4488'
  },

  // OpenRouter API Configuration
  openRouterApiUrl: 'https://openrouter.ai/api/v1'
};
